export enum ErrorStatus {
    NOT_INICIALIZED = 0,
    RUN = 1,
    HAS_ERROR = 2,
    HAS_NOT_ERROR = 3
}